import angular from 'angular';
import uiRouter from 'angular-ui-router';
import homeComponent from './home.component';
import homeService from './home.service';

let homeModule = angular.module('home', [
    uiRouter
  ])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";
    $urlRouterProvider.otherwise('/');
    $stateProvider
      .state('mainmenu', {
        url: '/:lang/:id',
        template: '<div class="subContainer" ui-view></div><home class="homeContainer" ng-if="\'mainmenu\' | isState"></home>',
        params: {
          id: null,
          lang: null
        }
      });
  })

  .component('home', homeComponent)
  .service('homeService', homeService)

  .name;

export default homeModule;



// WEBPACK FOOTER //
// ./client/app/components/home/home.js